import { useParams, Link } from 'react-router-dom';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { ChevronLeft, Shield } from 'lucide-react';
import EventAdminsManager from '@/components/events/EventAdminsManager';
import { EventsPageShell } from '../components/EventsPageShell';

export default function EventAdminsPage() {
  const { communityId, eventId } = useParams();

  return (
    <EventsPageShell maxWidthClassName="max-w-4xl">
      <div className="space-y-8">
        <div className="space-y-2">
          <Link
            to={`/${communityId}/events/${eventId}/manage`}
            className="text-sm text-muted-foreground hover:text-primary transition-colors flex items-center w-fit mb-4 group"
          >
            <div className="bg-muted p-1 rounded-md mr-2 group-hover:bg-primary/10 transition-colors">
              <ChevronLeft className="w-4 h-4" />
            </div>
            Back to Management Hub
          </Link>
          <div className="flex flex-col gap-2">
            <h1 className="text-4xl font-black tracking-tighter flex items-center gap-3">
              <div className="bg-primary/10 p-2 rounded-2xl shadow-sm border border-primary/20">
                <Shield className="w-8 h-8 text-primary" />
              </div>
              Event Administrators
            </h1>
            <p className="text-muted-foreground text-lg max-w-2xl leading-relaxed">
              Manage users who have administrative access to this specific event.
            </p>
          </div>
        </div>

        <Card className="border-border/40 bg-card/50 backdrop-blur-sm overflow-hidden shadow-xl shadow-primary/5">
          <CardHeader className="bg-muted/30 border-b border-border/50">
            <CardTitle className="text-xl font-bold">Admin Management</CardTitle>
            <CardDescription>
              Assign additional members to help manage this event's registrations and check-ins.
            </CardDescription>
          </CardHeader>
          <CardContent className="p-6">
            {communityId && eventId && (
              <EventAdminsManager eventId={eventId} communityId={communityId} />
            )}
          </CardContent>
        </Card>
      </div>
    </EventsPageShell>
  );
}
